import {AppearanceProvider} from 'components/common/CartItemBuilder/providers/AppearanceProvider'
import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import {ErrorMessage} from 'components/common/ErrorMessage'
import {get} from 'lodash'
import {useHideAddToCartAndKeepBrowsingButton} from 'providers/EnvironmentProvider'
import {useEffect, useState} from 'react'
import addTrackingError from 'utils/addTrackingError'
import {AddButton} from './AddButton'
import {BookButton} from './BookButton'
import {SaveButton} from './SaveButton'

export const Applaying = () => {
  const builderManager = AppearanceProvider.useManager()
  const input = InputProvider.useInput()
  const [error, setError] = useState<unknown>()
  const hideAddToCartAndKeepBrowsingButton = useHideAddToCartAndKeepBrowsingButton()

  const handleError = (error: unknown) => {
    setError(error)

    const errorMessage =
      typeof error === 'string'
        ? error
        : get(error, 'response.data.errorMessage') || get(error, 'message') || 'Unknown error'

    addTrackingError(errorMessage)
  }

  useEffect(() => {
    setError(null)
  }, [input])

  return (
    <>
      {error && <ErrorMessage error={error} />}

      {builderManager.action === 'creatingFirst' && (
        <>
          {!hideAddToCartAndKeepBrowsingButton && <AddButton onError={handleError} />}
          <BookButton onError={handleError} />
        </>
      )}
      {builderManager.action === 'creatingMore' && <AddButton onError={handleError} />}
      {builderManager.action === 'editing' && <SaveButton onError={handleError} />}
    </>
  )
}
